import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { ILoteItineranteForm } from "../../../../types/loteAgendamento";

export const useVincularItineranteLoteAgendamento = () => {
  return useMutation({
    mutationFn: (data: ILoteItineranteForm) =>
      LoteAgendamento.vincularItinerante(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
